import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

const getUserBehavioralDiscounts = async ({ params: { menuSlug } }) => {
  const response = await fetchWrapper(
    hcUrlV3(`/weekly_baskets/${menuSlug}/user_behavioral_discounts`),
    buildOpts()
  );
  return handleResponse(response);
};

export { getUserBehavioralDiscounts };
